import { HTTPError } from 'ky';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ShopTypes } from '~/lib/data-contract';
import useBasketReference from '~/services/shop/hooks/selectors/basket/useBasketReference';
import { useBasketTimer } from '~/shared/utils/storage';
import { setDeliveryAddress } from '../../operations/basket';

export default function useDeliveryAddress(deliveryId: number) {
    const queryClient = useQueryClient();
    const { data: reference } = useBasketReference();
    const [, setTimer] = useBasketTimer();

    return useMutation<Basket, HTTPError | Error, Arguments>(
        ({ address }) => setDeliveryAddress(deliveryId, address, reference),
        {
            onSuccess: (data) => {
                queryClient.setQueryData(['basket', { reference: data.basketReference }], data);
                setTimer(data.updated.toString());
            },
        },
    );
}

type Basket = ShopTypes.BasketResponse;
type Arguments = { address: ShopTypes.AddressDetails };
